import highSchoolCourses from '@/data/highSchoolCourses'
import { useCalculatorStore } from '@/store/calculatorStore'

export function useChangeHighSchool() {
  const setDiploma = useCalculatorStore((state) => state.setDiploma)
  const removeCourse = useCalculatorStore((state) => state.removeCourse)
  const addCourse = useCalculatorStore((state) => state.addCourse)
  const allCourses = useCalculatorStore((state) => state.courses)

  return (diplomaId: keyof typeof highSchoolCourses) => {
    const coursesToAdd =
      highSchoolCourses[diplomaId as keyof typeof highSchoolCourses]

    for (const course of allCourses) {
      if (coursesToAdd.includes(course.id)) {
        addCourse(course.id)
      } else {
        removeCourse(course.id)
      }
    }

    setDiploma(diplomaId, 'input')
  }
}
